export interface IGtmEcommerceOfferItemBaseProps {
    id: string | number;
    name: string;
    vendor: {
        name: string;
    };
}

export const getGtmEcommerceOfferItemBaseProps = (offer: IGtmEcommerceOfferItemBaseProps) => {
    return {
        item_id: offer.id.toString(),
        item_name: offer.name,
        item_brand: offer.vendor.name
    };
};
export interface IGtmEcommerceOfferItemBaseProps {
    id: string | number;
    name: string;
    vendor: {
        name: string;
    };
}

export const getGtmEcommerceOfferItemBaseProps = (offer: IGtmEcommerceOfferItemBaseProps) => {
    return {
        item_id: offer.id.toString(),
        item_name: offer.name,
        item_brand: offer.vendor.name
    };
};
